import BaseApi from './baseApi';

export default class MessageApi extends BaseApi {
  static sendMessage(message) {
    const messageJson = JSON.stringify(message);
    const config = {
      method: 'post',
      headers: this.getAuthHeaders(),
    };
    return this.axiosInstance.post(`${this.API}/message/send`, messageJson, config);
  }

  static getWhatsappTemplates() {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };
    return this.axiosInstance.get(`${this.API}/whatsapp/templates`, config);
  }

  static getMessagingHistory(filters = {}) {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    const url = new URL(`${this.API}/messaging/history`);

    // Add query parameters for filtering
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        if (key === 'companyIds' && Array.isArray(filters[key])) {
          url.searchParams.append(key, filters[key].join(','));
        } else {
          url.searchParams.append(key, filters[key]);
        }
      }
    });

    return this.axiosInstance.get(url.toString(), config);
  }

  static getCampaigns(type) {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    const url = new URL(`${this.API}/messaging/campaigns`);

    if (type) {
      url.searchParams.append('type', type);
    }

    return this.axiosInstance.get(url.toString(), config);
  }

  static createCampaigns(data) {
    const config = {
      method: 'post',
      headers: this.getAuthHeaders(),
    };
    return this.axiosInstance.post(`${this.API}/messaging/campaigns`, data, config);
  }

  static updateCampaigns(data) {
    const config = {
      method: 'put',
      headers: this.getAuthHeaders(),
    };
    return this.axiosInstance.put(`${this.API}/messaging/campaigns`, data, config);
  }

  static deleteCampaigns(campaignIds) {
    const config = {
      method: 'delete',
      headers: this.getAuthHeaders(),
      data: { campaignIds },
    };

    return this.axiosInstance.delete(`${this.API}/messaging/campaigns`, config);
  }

  static uploadCampaignMedia(file) {
    const formData = new FormData();
    formData.append('file', file);

    const config = {
      headers: this.getAuthHeaders({ contentType: 'multipart/form-data' }),
    };

    return this.axiosInstance.post(`${this.API}/messaging/media`, formData, config);
  }

  static generateEngagementReport(messageId) {
    const config = {
      method: 'post',
      headers: this.getAuthHeaders(),
    };

    const data = {
      reportName: 'messaging-engagement',
      filters: {},
      params: {
        messageId: messageId
      }
    };
    return this.axiosInstance.post(`${this.API}/admin/reports`, data, config);
  }
}
